var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43526 8.355L1.83826 4.2435C1.41376 3.75975 1.75876 3 2.40301 3H9.59701C9.74119 2.99988 9.88236 3.04132 10.0036 3.11936C10.1248 3.1974 10.221 3.30873 10.2806 3.44002C10.3402 3.57131 10.3607 3.717 10.3396 3.85963C10.3185 4.00227 10.2568 4.1358 10.1618 4.24425L6.56476 8.35425C6.49436 8.43481 6.40755 8.49937 6.31014 8.54361C6.21273 8.58785 6.10699 8.61074 6.00001 8.61074C5.89303 8.61074 5.78728 8.58785 5.68988 8.54361C5.59247 8.49937 5.50565 8.43481 5.43526 8.35425V8.355Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDownArrow);
export default __webpack_public_path__ + "static/media/filter_down_arrow.5c097c2cababf4be7c3a9a7d53ce7ad5.svg";
export { ForwardRef as ReactComponent };